<!--title -->
<app-modal-title [title]="'common.header'|translate" [isShowClose]="true" (isCloseModal)="onClose()"></app-modal-title>

<div mat-dialog-content class="dialog-content">
  <!-- form -->
  <form [formGroup]="form">
    <div class="row" style="max-width: 500px">
      <div class="tw-w-full">
        <!-- privateNumber header -->
        <div class="tw-my-1">
          <form-textarea
          #smsHeader
          class="tw-w-full"
          label="common.privateNumberHeader"
          (valueChange)="onChangeSmsHeader(smsHeader.value)"
          [control]="form?.get('smsHeader')"
          [rows]="2"
        >
        </form-textarea>
        </div>

        <!-- organization Header -->
        <div class="tw-my-1">
          <form-textarea
          #organSmsHeader
          class="tw-w-full"
          label="common.organizationHeader"
          (valueChange)="onChangeOrganSmsHeader(organSmsHeader.value)"
          [control]="form?.get('organizationSmsHeader')"
          [rows]="2"
        >
        </form-textarea>
        </div>

        <!-- position -->
        <div class="tw-my-2">
          <custom-select-search
            label="common.position"
            [items]="
              $any([
                {
                  value: false,
                  name: 'common.privateNumberSmsHeaderAtFirst' | translate
                },
                {
                  value: true,
                  name: 'common.organSmsHeaderAtFirst' | translate
                }
              ])
            "
            [control]="form?.get('smsHeaderPosition')"
            optionTitle="name"
            optionValue="value"
            [removable]="false"
            [(value)]="isOrganSmsHeaderAtFirst"
            (valueChange)="onChangeSmsHeaderPosition($event)"
          >
          </custom-select-search>
        </div>
      </div>

      <div class="tw-w-full">
        <!-- smsBodyWithHeaders -->
        <div class="tw-my-1">
          <form-textarea
          class="tw-w-full"
          label="common.smsBody"
          [(value)]="smsBodyWithHeaders"
          [control]="form?.get('smsBody')"
          [rows]="5"
        >
        </form-textarea>
        </div>
      </div>
    </div>

    <!-- submit btn -->
    <div class="tw-flex tw-justify-end">
      <div
        class="tw-flex tw-justify-end tw-w-full tw-mt-2"
        style="max-width: 275px"
      >
        <a
          mat-ripple
          class="btn tw-ml-[5px] ltr:tw-mr-[5px] tw-w-1/2 button-shadow btn-hover-rise"
          [themeColor]="'cancel-btn'"
          (click)="onClose()"
        >
          {{ "common.cancel" | translate }}
        </a>

        <button
          type="button"
          (click)="onSuccess()"
          mat-ripple
          class="btn tw-w-full button-shadow btn-hover-rise"
          [themeColor]="'btn'"
          [disabled]="!form.valid"
        >
          <span>{{ "common.submit" | translate }}</span>
        </button>
      </div>
    </div>
  </form>
</div>
